.seen-by {
  flex-shrink: 0;
}
